import AppController from '../app/app.controller';

/**
 * global logout controller
 **/
export default class AppLogoutController extends AppController {
	/**
	 * define required services here
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector) {
		super($injector);
		this.AuthService = $injector.get('AuthService');
		this.$rootRouter = $injector.get('$rootRouter');
		this.ToastService = $injector.get('ToastService');
	}

	/**
	 * log the user out and navigate to the login view
	 **/
	$routerOnActivate(next, prev) {
		this.AuthService.logout()
			.then((response) => {
				this.$rootRouter.navigate(['Daisy']);
				this.ToastService.toast('Sie haben sich erfolgreich abgemeldet.');
				this.Socket.emit('socket:logout');
			})
			.catch((err) => {
				this.ToastService.danger('Fehler bei der Abmeldung.');
			});
	}
}
